import { setBrowserMode } from '@/reducers/menus';
import { setUID, setUserData } from '@/reducers/users';
import React from 'react';
import { connect } from 'react-redux';

const SimpleHOC = (WrappedComponent) => {
  class SimpleComponent extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        show: true,
      };
    }

    componentDidMount() {
      let searchParams = new URL(window.location.href).searchParams;

      // 判断是否是简易模式
      if (this.props.browserMode && this.props.browserMode == 'simple') {
        document.documentElement.style.setProperty('--navber-height', '0px');
        this.setState({ show: false });
      } else {
        // 获取mode参数并判断
        const args = searchParams.get('mode');
        if (args && args == 'simple') {
          this.props.handleSetBrowserMode('simple');
          document.documentElement.style.setProperty('--navber-height', '0px');
          this.setState({ show: false });
        } else {
          // 恢复默认值，和 global.scss 保持一致
          document.documentElement.style.setProperty('--navber-height', '66px');
        }
      }
    }

    render() {
      return this.state.show ? <WrappedComponent {...this.props} /> : null;
    }
  }
  const mapStateToProps = (state) => ({
    browserMode: state.menus.browserMode,
  });

  const mapDispatchToProps = (dispatch) => ({
    handleSetBrowserMode: (mode) => dispatch(setBrowserMode(mode)),
    handleSetUserData: (data) => dispatch(setUserData(data)),
    handleSetUid: (data) => dispatch(setUID(data)),
  });

  return connect(mapStateToProps, mapDispatchToProps)(SimpleComponent);
};

export default SimpleHOC;
